import { useEffect, type ReactNode } from 'react';
import { initScrollRevealObserver } from '@agenda-facil/ui';
import { PageLoader } from '../components/query-feedback';
import { refreshSession } from '../lib/api';
import { applyTheme, useThemeStore } from '../stores/theme-store';
import { useAuthStore } from '../stores/auth-store';

export function SessionBootstrap({ children }: { children: ReactNode }) {
  const hydrated = useAuthStore((state) => state.hydrated);
  const preference = useThemeStore((state) => state.preference);
  const pathname = globalThis.location?.pathname ?? '/';
  const requiresSession =
    pathname === '/onboarding' ||
    pathname === '/app' ||
    pathname.startsWith('/app/') ||
    pathname === '/admin' ||
    pathname.startsWith('/admin/');

  useEffect(() => {
    applyTheme(preference);
    const media = matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => preference === 'system' && applyTheme('system');
    media.addEventListener('change', handleChange);

    const cleanupReveal = initScrollRevealObserver();

    return () => {
      media.removeEventListener('change', handleChange);
      cleanupReveal();
    };
  }, [preference]);

  useEffect(() => {
    if (!hydrated) void refreshSession();
  }, [hydrated]);

  if (!hydrated && requiresSession) return <PageLoader label="Preparando sua agenda…" />;
  return children;
}
